module.exports = __webpack_public_path__ + "img/afiliado.4a12686b.svg";